// import { createSlice } from "@reduxjs/toolkit";
// import { useAppDispatch } from "../../hooks";
// import { clearUserId } from "../users/userSlice";



// const authSlice = createSlice({
//   name: "auth",
//   initialState: {
//     isAuthenticated: false,
//     loginTime:null
//   },
//   reducers: {
//     login(state,actions) {

//       sessionStorage.setItem("Auth-Token", actions.payload);

//       state.isAuthenticated = true;
//     },
//     logout(state) {
//       sessionStorage.removeItem("Auth-Token");
//       state.isAuthenticated = false;
//       state.loginTime =null;

//     },
//     setLoginTime(state,action){
//         state.loginTime = action.payload;

//     }
//   },
// });

// export const { login, logout, setLoginTime } = authSlice.actions;
// export default authSlice.reducer;

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface User {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  mobileNumber: string;
  gender: string;
  dob: string;
  address: string;
}

interface AuthState {
  isAuthenticated: boolean;
  token: string | null;
  user: User | null;
  sid: number | null;
  duid: string | null;
  phoneNumber: string | null;
   loginTime:null
}

// ✅ Login payload
interface LoginPayload {
  token: string;
  sid: number;
}

const initialState: AuthState = {
  isAuthenticated: Boolean(sessionStorage.getItem("authToken")),
  token: sessionStorage.getItem("authToken"),
  user: sessionStorage.getItem("User-Details")
    ? JSON.parse(sessionStorage.getItem("User-Details") as string)
    : null,
  sid: sessionStorage.getItem("SID")
    ? Number(sessionStorage.getItem("SID"))
    : null,
  duid: sessionStorage.getItem("duid") || null,
  phoneNumber : null,
   loginTime:null
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login(state, action) {
      const { token } = action.payload;
      sessionStorage.setItem("Auth-Token", token);

      state.token = token;

      state.isAuthenticated = true;

    },

    setUser(state, action: PayloadAction<User>) {
      const user = action.payload;
      sessionStorage.setItem("User-Details", JSON.stringify(user));
      state.user = user;
    },

    setSid(state, action: PayloadAction<number>) {
      state.sid = action.payload;
      console.log(state.sid)
      sessionStorage.setItem("SID", String(action.payload));
    },

    setDuid(state, action: PayloadAction<string>) {
      state.duid = action.payload;
      console.log(state.duid);
      sessionStorage.setItem("duid", action.payload);
    },


    setPhoneNumber: (state, action: PayloadAction<string>) => {
      state.phoneNumber = action.payload; // <-- store phone number
    },

    logout(state) {
      sessionStorage.removeItem("authToken");
      sessionStorage.removeItem("User-Details");
      sessionStorage.removeItem("SID");
      sessionStorage.removeItem("duid");
      state.token = null;
      state.user = null;
      state.sid = null;
      state.duid = null;
      state.isAuthenticated = false;
    },

    setIsAuthenticated(state, action: PayloadAction<boolean>) {
  state.isAuthenticated = action.payload;
},

    updatePass(state) {
      state.isAuthenticated = true;
    },

     setLoginTime(state,action){
        state.loginTime = action.payload;

    }
  },
});

export const { login, logout, setUser, updatePass, setSid, setDuid,setIsAuthenticated, setPhoneNumber ,setLoginTime} = authSlice.actions;
export default authSlice.reducer;
